export default __webpack_public_path__ + "static/media/performance.a047ef52.svg";